import { AutoCompleteDesignTokens } from '@primeuix/themes/types/autocomplete';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const autocompleteOverride: AutoCompleteDesignTokens = {
  overlay: {
    background: getColor('UiWhite'),
    color: getColor('DarkBlue'),
    borderRadius: getRem(10),
  },

  list: {
    padding: `${getRem(6)} 0`,
    gap: '0',
  },

  option: {
    padding: `0 ${getRem(10)}`,
    color: getColor('DarkBlue'),
    focusBackground: getColor('Sandstone95'),
    focusColor: getColor('DarkBlue'),
  },

  emptyMessage: {
    padding: `0 ${getRem(10)}`,
  },
};
